/* Coordinate Shopify Inbox's closed launcher with the theme's fixed UI.
 * Uses the widget's CSS offset, not its private shadow DOM or cart state.
 */
(function () {
  'use strict';

  function init() {
    var root = document.documentElement;
    var purchaseSelector = '.RpTileTools, .PdpDualQty, .Product__Block--quantitySelector, .Product__Block--buyButtons';
    var trackedSelector = '.SampleBoxBuilder, .Drawer, [data-v2-sample-drawer], ' + purchaseSelector;
    var mobile = window.matchMedia('(max-width: 1007px)');
    var purchaseAreas = [];
    var purchaseVisibility = new WeakMap();
    var gap = 16;
    var builder = null;
    var drawers = [];
    var frame = null;
    var occupiedBottom = 0;

    function sync() {
      frame = null;
      var nextBottom = 0;
      if (builder && builder.isConnected && !builder.hidden) {
        var rect = builder.getBoundingClientRect();
        var styles = window.getComputedStyle(builder);
        if (styles.position === 'fixed' && rect.height > 0 && rect.width > 0 && styles.visibility !== 'hidden' && styles.display !== 'none') {
          // Includes the tray's desktop bottom margin and mobile safe-area padding.
          nextBottom = Math.max(0, Math.ceil(window.innerHeight - rect.top));
        }
      }

      if (nextBottom !== occupiedBottom) {
        occupiedBottom = nextBottom;
        if (occupiedBottom > 0) {
          root.style.setProperty('--rp-sample-tray-clearance', occupiedBottom + 'px');
          root.style.setProperty('--rp-chat-launcher-offset', (occupiedBottom + gap) + 'px');
        } else {
          root.style.removeProperty('--rp-sample-tray-clearance');
          root.style.removeProperty('--rp-chat-launcher-offset');
        }
      }
      root.classList.toggle('RPChatAvoidsSampleBox', occupiedBottom > 0);

      var drawerOpen = drawers.some(function (drawer) {
        // aria-modal remains set throughout the closing animation, preventing
        // the launcher from flashing back over a drawer that is still moving.
        return drawer.isConnected && (drawer.open || drawer.classList.contains('Show') ||
          (drawer.getAttribute('aria-modal') === 'true' && drawer.getAttribute('aria-hidden') !== 'true') ||
          drawer.getAttribute('aria-hidden') === 'false');
      });
      root.classList.toggle('RPChatDrawerOpen', drawerOpen);
      var purchaseVisible = mobile.matches && purchaseAreas.some(function (area) {
        if (!area.isConnected || area.hidden) return false;
        var styles = window.getComputedStyle(area);
        if (styles.display === 'none' || styles.visibility === 'hidden') return false;
        if (purchaseObserver) return purchaseVisibility.get(area) === true;
        var rect = area.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > -24 && rect.top < window.innerHeight + 24;
      });
      root.classList.toggle('RPChatPurchaseVisible', purchaseVisible);
    }

    function queueSync() {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(sync);
    }

    var purchaseObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { purchaseVisibility.set(entry.target, entry.isIntersecting); });
      queueSync();
    }, { rootMargin: '24px 0px' }) : null;
    var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(queueSync) : null;
    var stateObserver = 'MutationObserver' in window ? new MutationObserver(queueSync) : null;

    function bindElements() {
      if (resizeObserver) resizeObserver.disconnect();
      if (stateObserver) stateObserver.disconnect();
      if (purchaseObserver) purchaseObserver.disconnect();
      purchaseVisibility = new WeakMap();
      purchaseAreas = Array.prototype.slice.call(document.querySelectorAll(purchaseSelector));
      purchaseAreas.forEach(function (area) {
        if (purchaseObserver) purchaseObserver.observe(area);
        if (resizeObserver) resizeObserver.observe(area);
        if (stateObserver) stateObserver.observe(area, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
      });
      builder = document.querySelector('.SampleBoxBuilder');
      drawers = Array.prototype.slice.call(document.querySelectorAll('.Drawer, [data-v2-sample-drawer]'));

      if (builder) {
        if (resizeObserver) resizeObserver.observe(builder);
        if (stateObserver) stateObserver.observe(builder, {
          attributes: true, attributeFilter: ['hidden', 'class', 'style']
        });
      }
      if (stateObserver) drawers.forEach(function (drawer) {
        stateObserver.observe(drawer, {
          attributes: true, attributeFilter: ['class', 'aria-hidden', 'aria-modal', 'open']
        });
      });
      queueSync();
    }

    function containsTrackedElement(node) {
      return node.nodeType === 1 && (node.matches(trackedSelector) || node.querySelector(trackedSelector));
    }

    // Collection AJAX and theme-editor section replacements can replace a drawer
    // or builder. Ordinary product-card/text updates do not trigger a rebind.
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        var changed = mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes, containsTrackedElement) ||
            Array.prototype.some.call(mutation.removedNodes, containsTrackedElement);
        });
        if (changed) bindElements();
      }).observe(document.body, { childList: true, subtree: true });
    }

    ['show.tg.Drawer', 'shown.tg.Drawer', 'hide.tg.Drawer', 'hidden.tg.Drawer',
      'repubblica:sample_box_changed'].forEach(function (eventName) {
      document.addEventListener(eventName, queueSync, true);
    });
    window.addEventListener('resize', queueSync, { passive: true });
    mobile.addEventListener('change', queueSync);
    if (!purchaseObserver) window.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('pageshow', queueSync);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', queueSync, { passive: true });
    bindElements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
